<template>
  <div>
    <div class="container">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            v-loading="isFormLoading"
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="部門" label-width="50px">
              <el-select
                v-model="queryForm.dept"
                @change="handleDeptChange"
                size="small"
                class="selectqry"
              >
                <el-option
                  v-for="item in myDepts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="頻道" label-width="50px">
              <el-select
                v-model="queryForm.chnl"
                size="small"
                class="selectqry"
              >
                <el-option
                  v-for="item in myChnls"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                 <el-tooltip v-if="item.isSystem" content="系統頻道，勿公開、勿分享">
                <i class="el-icon-setting">{{ item.name }}</i>
               </el-tooltip>
                <span v-else
                  >{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                size="small"
                :disabled="hasNoValidChnl"
                style="width:130px"
                v-model="queryForm.qstr"
                placeholder="名稱"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                :disabled="hasNoValidChnl"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-dropdown
            class="mr-2"
            @command="handleSubsChnl"
          >
            <el-button type="primary" size="small">
              批次訂閱<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="batch-mbr">個人訂閱</el-dropdown-item>
              <el-dropdown-item command="batch-grp">群組訂閱</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown
            v-if="!hasNoActiveChnl && !canGoUpFolder()"
            class="mr-2"
            @command="handleSubsChnl"
          >
            <el-button type="primary" size="small">
              全頻道訂閱<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="mbr">個人訂閱</el-dropdown-item>
              <el-dropdown-item command="grp">群組訂閱</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-button
            type="primary"
            icon="el-icon-top"
            @click="gotoFolder(null)"
            :disabled="hasNoActiveChnl || !canGoUpFolder()"
            size="small"
            >回上一層</el-button
          >

          <el-button
            type="primary"
            @click="exportAssets(null)"
            :disabled="hasNoActiveChnl"
            size="small"
            >匯出音檔清單</el-button
          >

          <!--<el-button-->
          <!--size="small"-->
          <!--type="primary"-->
          <!--@click="batchGrantAssets"-->
          <!--:disabled="selectedRow.length === 0 || !anySelectedGrantable" >批次個人授權</el-button >-->
        </div>
      </div>
    </div>

    <CCard style="user-select: none;">
      <CCardHeader class="py-0">
        <div v-if="hasInited && hasNoActiveChnl" class="py-3">
          <CIcon name="cib-apple-podcasts" class="headericon" />
          {{ getDeptName(activeQueryForm.dept) }} / (沒有授權的頻道)
        </div>

        <CRow v-else>
          <div class="container" style="margin:0">
            <div class="row ">
              <div class="headerpanel">
                <CIcon name="cib-apple-podcasts" class="headericon" />
                {{ getDeptName(activeQueryForm.dept) }} /
              </div>

              <div class="ml-3">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item
                    v-for="(node, idx) in folderTree"
                    :key="`node_{${node.assetId}}`"
                  >
                    <el-button
                      type="text"
                      :disabled="isLeafNode(idx)"
                      @click="handleNodeClk(idx)"
                      >{{ node.assetName }}
                      <i v-if="node.assetIsEncrypt" class="el-icon-lock"></i>
                    </el-button>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
          </div>
        </CRow>
      </CCardHeader>
      <CCardBody @mousedown="handleMouseDown">
        <CRow>
          <el-table
          :border="true"
            ref="dataTable"
            v-loading="isLoading"
            :data="assets"
            @sort-change="sortChange"
            :default-sort="{ prop: 'startDate', order: 'descending' }"
            stripe
            @row-dblclick="handleRowDbClk"
            @selection-change="handleSelectionChange"
            style="width: 100%"
            :row-class-name="rowClassName"
          >
            <el-table-column type="selection" width="45" class-name="checkbox"> </el-table-column>

            <el-table-column type="index" :index="indexFormatter" fixed>
            </el-table-column>

            <el-table-column
              label="名稱"
              prop="name"
              sortable="custom"
              width="360"
            >
              <template #default="scope">
                <img
                  v-if="!scope.row.isLeaf"
                  src="./../assets/icons/folder.svg"
                  class="foldericon"
                />
                <img v-else src="./../assets/icons/file.svg" class="fileicon" />
                <!--<i v-if="!scope.row.isLeaf" class="el-icon-folder"></i>-->
                <!--<i v-else class="el-icon-document"></i>-->

                <span class="ml-3">
                  {{ scope.row.name }}
                </span>
                <el-popover
                  v-if="scope.row.isEncrypt"
                  title="失效日"
                  width="200"
                  trigger="hover"
                >
                  <span v-if="scope.row.encryptExpiredMode == 'absolute'">
                    {{ convertTime(new Date(parseInt(scope.row.endDate))) }}
                  </span>
                  <span v-else
                    >下載後 {{ scope.row.endDateAmount }}
                    {{ formatDateUnit(scope.row.endDateUnit) }}</span
                  >

                  <i slot="reference" class="el-icon-lock"></i>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column
              label="上次修改時間"
              prop="lastUpdateDate"
              sortable="custom"
              width="200"
            >
              <template #default="scope">
                {{ convertTime(scope.row.lastUpdateDate) }}
              </template>
            </el-table-column>

            <el-table-column label="大小" prop="size" width="100">
              <template #default="scope">
                <div v-if="scope.row.isLeaf">
                  {{ getReadableSize(scope.row.size) }}
                </div>
                <!--<div v-else-if="scope.row.size !== null">-->
                <div v-else-if="scope.row.size !== null" style="word-break: keep-all">
                  {{ scope.row.size }}
                </div>
                <div v-else>
                  <img
                    src="./../assets/icons/info.svg"
                    class="infoicon"
                    @click="getFolderSize(scope.row, scope.$index)"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="備註"
              prop="description"
              width="200"
            >
            </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <el-button size="mini" @click="MbrSubsAsset(scope.row)"
                  >個人訂閱
                </el-button>

                <el-button size="mini" @click="GrpSubsAsset(scope.row)"
                  >群組訂閱
                </el-button>

                <!--<el-button size="mini" @click="grantAsset(scope.row)" >個人授權-->
                <!--</el-button>-->

                <el-button
                  v-if="isAssetPlayable(scope.row)"
                  size="mini"
                  @click="playAsset(scope.row)"
                  >播放
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>
      </CCardBody>
    </CCard>
    <DeptExportAssetDlg
      v-model="isExportDlgVisible"
      :deptId="activeQueryForm.dept"
      :deptName="selDeptName"
      :key="`export_${exportDlgKey}`"
    ></DeptExportAssetDlg>

    <MbrAssetSubsDlg
      v-model="isSubsDlgVisible"
      :assetId="selectAssetId"
      :deptId="activeQueryForm.dept"
      :channelId="activeQueryForm.chnl"
      :channelName="getChnlName(activeQueryForm.chnl)"
      :assetName="selAssetName"
      :deptName="selDeptName"
      :key="`subs_${subsDlgKey}`"
    ></MbrAssetSubsDlg>

    <GrpAssetSubsDlg
      v-model="isGrpSubsDlgVisible"
      :assetId="selectAssetId"
      :deptId="activeQueryForm.dept"
      :channelId="activeQueryForm.chnl"
      :channelName="getChnlName(activeQueryForm.chnl)"
      :assetName="selAssetName"
      :deptName="selDeptName"
      :key="`grpsubs_${grpSubsDlgKey}`"
    ></GrpAssetSubsDlg>

    <BatchMbrAssetSubsDlg
      v-model="isBatchSubsDlgVisible"
      :assets="selectedRow"
      :deptId="activeQueryForm.dept"
      :channelId="activeQueryForm.chnl"
      :channelName="getChnlName(activeQueryForm.chnl)"
      :deptName="selDeptName"
      :key="`batchSubs_${batchSubsDlgKey}`"
    ></BatchMbrAssetSubsDlg>

        <BatchGrpAssetSubsDlg
      v-model="isBatchGrpSubsDlgVisible"
      :assets="selectedRow"
      :deptId="activeQueryForm.dept"
      :channelId="activeQueryForm.chnl"
      :channelName="getChnlName(activeQueryForm.chnl)"
      :deptName="selDeptName"
      :key="`batchGrpSubs_${batchGrpSubsDlgKey}`"
    ></BatchGrpAssetSubsDlg>
    <!--<DeptChnlGrantDlg-->
    <!--v-model="isGrantDlgVisible"-->
    <!--:assetIds="selectAssetIds"-->
    <!--:deptId="activeQueryForm.dept"-->
    <!--:channelId="activeQueryForm.chnl"-->
    <!--:assetName="selAssetName"-->
    <!--:deptName="selDeptName"-->
    <!--:key="`grant_${grantDlgKey}`" ></DeptChnlGrantDlg>-->

    <PlayerDlg
      v-model="isPlayDlgVisible"
      :assetName="selAssetName"
      :selectedItemId="selectedItemId"
      :key="`play_${playDlgKey}`"
    ></PlayerDlg>

    <AddEdtAssetDlg
      v-model="isDlgVisible"
      :selectedItemId="selectedItemId"
      :parentId="parentId"
      :isFolder="isSelectedFolder"
      :key="`addEdtAsset_${dlgKey}`"
    ></AddEdtAssetDlg>
    <div ref="selectionBox" class="selectionBox"></div>
  </div>
</template>

<script>
import appConfig from "@/appConfig";
import { mapGetters } from "vuex";
import AddEdtAssetDlg from "@/components/channel/AddEdtAssetDlg";
import MbrAssetSubsDlg from "@/components/dept/MbrAssetSubsDlg";
import BatchMbrAssetSubsDlg from "@/components/dept/BatchMbrAssetSubsDlg";
import DeptExportAssetDlg from "@/components/dept/DeptExportAssetDlg";
import GrpAssetSubsDlg from "@/components/dept/GrpAssetSubsDlg";
import BatchGrpAssetSubsDlg from "@/components/dept/BatchGrpAssetSubsDlg";
//import DeptChnlGrantDlg from "@/components/dept/DeptChnlGrantDlg";
import PlayerDlg from "@/components/channel/PlayerDlg";
import tagColorsMixin from "@/components/mixin/tagColors.js";
import moment from "moment-timezone";
import API from "@/api/";
export default {
  name: "orgChnlList",
  mixins: [tagColorsMixin],
  components: {
    AddEdtAssetDlg,
    //DeptChnlGrantDlg,
    MbrAssetSubsDlg,
    GrpAssetSubsDlg,
    DeptExportAssetDlg,
    PlayerDlg,
    BatchMbrAssetSubsDlg,
    BatchGrpAssetSubsDlg,
  },
  created() {
    this.$store.commit("asset/CLEAR");
    API.my
      .depts()
      .then(res => {
        this.myDepts = res.data;
        if (res.data.length) {
          this.queryForm.dept = res.data[0].id;
          this.activeQueryForm.dept = res.data[0].id;
          return res.data[0].id;
        } else {
          return null;
        }
      })
      .then(activeDept => {
        if (activeDept) {
          //this.isFormLoading = true;
          return this.getDeptChannels(activeDept);
        } else {
          return [];
        }
      })
      .then(channels => {
        if (channels.length) {
          this.activeQueryForm.chnl = channels[0].id;
          this.getChannelAsset();
        }
      })
      .finally(() => {
        //this.isFormLoading = false
        this.hasInited = true;
      });
  },
  data() {
    return {
      selectedRow: [],
      //selectAssetIds: [],
      selectAssetId: null,
      hasInited: false,
      selectedItemId: null,
      isFormLoading: false,
      isLoading: false,
      parentId: null,
      isSelectedFolder: false,
      selDeptName: "",
      selAssetName: "",
      folderTree: [],
      myDepts: [],
      myChnls: [],
      dlgKey: 0,
      playDlgKey: 0,
      //grantDlgKey: 0,
      exportDlgKey: 0,
      subsDlgKey: 0,
      grpSubsDlgKey: 0,
      batchSubsDlgKey: 0,
      batchGrpSubsDlgKey: 0,
      edtAdmDlgKey: 0,
      isDlgVisible: false,
      isPlayDlgVisible: false,
      //isGrantDlgVisible: false,
      isSubsDlgVisible: false,
      isBatchSubsDlgVisible: false,
      isExportDlgVisible: false,
      isGrpSubsDlgVisible: false,
      isBatchGrpSubsDlgVisible: false,
      pageSize: 10,
      queryForm: {
        qstr: "",
        dept: undefined,
        chnl: undefined,
      },
      activeQueryForm: {
        qstr: "",
        dept: undefined,
        chnl: undefined,
      },
      selectionBox: null,
      isSelecting: false,
      startX: 0,
      startY: 0,
      selectAbles: [],
      oldSelectRow: [],
      isShiftKey: false,
    };
  },
  methods: {
    getFolderSize(asset, idx) {
      this.isLoading = true;
      API.asset.getAssetSize(asset.id).then(res => {
        const { size, count } = res.data;
        console.log(`getFolderSize: size = ${size}, count = ${count}`);

        const newAsset = { ...asset };
        newAsset.size = `${this.getReadableSize(size)}/ ${count}個檔案`;

        const payload = {
          newElem: newAsset,
          index: idx,
        };
        this.$store.commit("asset/CHANGE_ELEMENT", payload);
      })
      .finally(() => {
        this.isLoading = false;
      })
      ;
    },
    getReadableSize(bytes, decimals = 2) {
      if (bytes == 0) return "0 Byte";
      var base = 1024,
        sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        i = Math.floor(Math.log(bytes) / Math.log(base));
      return (
        parseFloat((bytes / Math.pow(base, i)).toFixed(decimals)) +
        " " +
        sizes[i]
      );
    },
    handleSubsChnl(command) {
      switch(command){
        case "mbr":
          this.mbrSubsChnl();
          break;
        case "grp":
          this.grpSubsChnl();
          break;
        case "batch-mbr":
          this.batchMbrSubsAsset()
          break;
        case "batch-grp":
          this.batchGrpSubsAsset()
          break;
      }
    },

    exportAssets() {
      this.selDeptName = this.getDeptName(this.activeQueryForm.dept);
      this.exportDlgKey = this.exportDlgKey ? 0 : 1;
      this.isExportDlgVisible = true;
    },

    mbrSubsChnl() {
      this.selectAssetId = 0;
      this.selAssetName = "";
      this.selDeptName = this.getDeptName(this.activeQueryForm.dept);
      this.subsDlgKey = this.subsDlgKey ? 0 : 1;
      this.isSubsDlgVisible = true;
    },

    grpSubsChnl() {
      this.selectAssetId = 0;
      this.selAssetName = "";
      this.selDeptName = this.getDeptName(this.activeQueryForm.dept);
      this.grpSubsDlgKey = this.grpSubsDlgKey ? 0 : 1;
      this.isGrpSubsDlgVisible = true;
    },

    isFilePlayable(fileName) {
      const playableExt = appConfig.PLAYABLE_EXT;
      const ext =
        fileName.indexOf(".") > -1
          ? fileName
              .split(".")
              .pop()
              .toLowerCase()
          : "";
      return playableExt.some(item => item === ext);
    },
    isAssetPlayable(item) {
      if (!item.isLeaf) {
        return false;
      } else {
        return this.isFilePlayable(item.name);
      }
    },
    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },
    formatDateUnit(unit) {
      switch (unit) {
        case "years":
          return "年";
        case "months":
          return "月";
        case "days":
          return "日";
      }
    },

    //batchGrantAssets() {
    //const assetIds = this.selectedRow.map(row => row.id);
    //this.selectAssetIds = assetIds;
    //this.selAssetName = "(多個檔案)";
    //this.selDeptName = this.getDeptName(this.activeQueryForm.dept);
    //this.grantDlgKey = this.grantDlgKey ? 0 : 1;
    //this.isGrantDlgVisible = true;
    //this.$refs.dataTable.clearSelection();
    //},

    //grantAsset(item) {
    //this.selectAssetIds = [item.id];
    //this.selAssetName = item.name;
    //this.selDeptName = this.getDeptName(this.activeQueryForm.dept);
    //this.grantDlgKey = this.grantDlgKey ? 0 : 1;
    //this.isGrantDlgVisible = true;
    //},

    GrpSubsAsset(item) {
      this.selectAssetId = item.id;
      this.selAssetName = item.name;
      this.selDeptName = this.getDeptName(this.activeQueryForm.dept);
      this.grpSubsDlgKey = this.grpSubsDlgKey ? 0 : 1;
      this.isGrpSubsDlgVisible = true;
    },

    MbrSubsAsset(item) {
      this.selectAssetId = item.id;
      this.selAssetName = item.name;
      this.selDeptName = this.getDeptName(this.activeQueryForm.dept);
      this.subsDlgKey = this.subsDlgKey ? 0 : 1;
      this.isSubsDlgVisible = true;
    },
    batchGrpSubsAsset() {
      console.log('batchGrpSubsAsset')
      this.selDeptName = this.getDeptName(this.activeQueryForm.dept);
      this.batchGrpSubsDlgKey = this.batchGrpSubsDlgKey ? 0 : 1;
      this.isBatchGrpSubsDlgVisible = true;
    },

    batchMbrSubsAsset() {
      this.selDeptName = this.getDeptName(this.activeQueryForm.dept);
      this.batchSubsDlgKey = this.batchSubsDlgKey ? 0 : 1;
      this.isBatchSubsDlgVisible = true;
    },
    playAsset(item) {
      this.selectedItemId = item.id;
      this.selAssetName = item.name;
      this.playDlgKey = this.playDlgKey ? 0 : 1;
      this.isPlayDlgVisible = true;
    },
    getDeptName(deptId) {
      const dept = this.myDepts.find(dept => dept.id === deptId);
      return dept?.name ?? "";
    },
    convertTime(tm) {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return moment(tm)
        .tz(tz)
        .format("YYYY-MM-DD hh:mm:ss A");
    },
    handleDeptChange(newDeptId) {
      //console.log(`handleDeptChange: newDeptId = ${newDeptId}`);
      this.isFormLoading = true;
      this.getDeptChannels(newDeptId).finally(() => {
        this.isFormLoading = false;
      });
    },
    getDeptChannels(deptId) {
      return API.channel
        .list({
          max: 99999,
          offset: 0,
          dept: deptId,
          sort: "name",
        })
        .then(res => {
          this.myChnls = res.data[0];
          if (res.data[0].length > 0) {
            this.queryForm.chnl = res.data[0][0].id;
            return res.data[0];
          } else {
            this.queryForm.chnl = undefined;
            return [];
          }
        });
    },
    isLeafNode(idx) {
      return idx === this.folderTree.length - 1 ? true : false;
    },
    handleNodeClk(idx) {
      this.gotoFolder(idx);
    },
    canGoUpFolder() {
      const idx = this.folderTree.length - 2;
      return idx >= 0 ? true : false;
    },
    //NOTE: if idx is null, go 1 level folder up
    gotoFolder(idx) {
      if (idx == null) {
        idx = this.folderTree.length - 2;
      }
      if (idx >= 0) {
        //console.log(`gotoFolder: folderTree = ${JSON.stringify(this.folderTree)}`)

        const target = this.folderTree[idx];
        //console.log(`gotoFolder: target = ${JSON.stringify(target)}`)
        const removeNodes = this.folderTree.splice(idx + 1);
        this.$store.commit("asset/setParentIsEncrypt", target.isEncrypt);
        //const curNode = this.folderTree.pop();
        this.getAssetContent(this.sort, this.order, {
          parent: target.assetId,
        }).catch(() => {
          this.folderTree = this.folderTree.cancat(removeNodes);
          //this.folderTree.push(curNode);
        });
      }
    },
    getChnlName(chnlId) {
      const foundChnl = this.myChnls.find(chnl => chnl.id === chnlId);
      return foundChnl ? foundChnl.name : "";
    },
    handleRowDbClk(row) {
      //console.log(`handleRowDbClk: row = ${JSON.stringify(row)}`);
      //console.log(`handleRowDbClk: column = ${JSON.stringify(column)}`);

      //@todo: ignore button clicked

      if (!row.isLeaf) {
        this.$store.commit("asset/setParentIsEncrypt", row.isEncrypt);
        this.folderTree.push({
          assetId: row.id,
          assetName: row.name,
          assetIsEncrypt: row.isEncrypt,
        });
        this.getAssetContent(this.sort, this.order, { parent: row.id }).catch(
          () => {
            this.folderTree.pop();
          }
        );
      }
    },
    addNewFolder() {
      this.parentId = this.$store.state.asset.parent;
      this.isSelectedFolder = true;
      this.selectedItemId = null;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isDlgVisible = true;
    },
    editAssetName(item) {
      this.selectedItemId = item.id;
      this.isSelectedFolder = !item.isLeaf;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isDlgVisible = true;
    },
    handleQueryClick(queryForm) {
      const queryNewChnl = queryForm.chnl !== this.activeQueryForm.chnl;
      this.activeQueryForm = { ...queryForm };
      if (queryNewChnl) {
        this.getChannelAsset(queryForm);
      } else {
        const newParams = { ...queryForm };
        delete newParams.chnl;
        this.getAssetContent(this.sort, this.order, newParams);
      }
    },

    //NOTE: params is used to assign qstr; channelId is given by activeQueryForm.chnl
    getChannelAsset(params = {}) {
      this.folderTree = [];
      const chnlName = this.getChnlName(this.activeQueryForm.chnl);
      this.isLoading = true;
      this.$store
        .dispatch("asset/getChannelAsset", {
          channelId: this.activeQueryForm.chnl,
          sort: this.sort,
          order: this.order,
          ...params,
        })
        .then(res => {
          this.folderTree.push({
            assetId: this.$store.state.asset.parent,
            assetName: chnlName,
          });
          //console.log(`getChannelAsset then: folderTree = ${JSON.stringify(this.folderTree)}`)
          return res;
        })
        .catch(err => {
          console.log(`getChannelAsset err = ${err}`);
          this.folderTree.push({ assetId: null, assetName: chnlName });
          //console.log(`getChannelAsset catch: folderTree = ${JSON.stringify(this.folderTree)}`)
          return err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    //NOTE: if parent is assigned in params, it will get content for another asset;
    //    Otherwise, it will just query for the current parent asset
    getAssetContent(sort, order, params = {}) {
      this.isLoading = true;
      return this.$store
        .dispatch("asset/getAssetContent", {
          sort,
          order,
          ...params,
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    indexFormatter(index) {
      return `#${index + 1}`;
    },
    delAsset(itemId) {
      this.$confirm("此操作將永久刪除該項目, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.asset.remove(itemId).then(() => {
            this.getAssetContent(this.sort, this.order, this.activeQueryForm);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          /*this.$message({*/
          /*type: 'info',*/
          /*message: '已取消删除'*/
          /*});          */
        });
    },
    sortChange(args) {
      if (this.hasNoActiveChnl) {
        return;
      }
      if (args.order === null) {
        this.$store.commit("asset/SET_SORT", "id");
        this.$store.commit("asset/SET_ORDER", "ascending");
      } else {
        this.$store.commit("asset/SET_SORT", args.prop);
        this.$store.commit("asset/SET_ORDER", args.order);
      }
      this.getAssetContent(this.sort, this.order, this.activeQueryForm);
    },
    rowClassName(data) {
      return `myRow-${data.rowIndex} mySelectable`
    },
    handleMouseDown(event) {
      this.isSelecting = true;
      this.startX = event.pageX;
      this.startY = event.pageY;

      this.updateSelectionBox(this.startX, this.startY, 0, 0);
      this.$refs.selectionBox.style.display = "block";

      this.selectAbles = this.$refs.dataTable.$el.querySelectorAll(".mySelectable")

      // 如果是checkbox, 因為會衝突故不清除
      this.isShiftKey = event.shiftKey;
      if(!event.target.className.includes("checkbox") && !event.target.querySelector('label')?.className.includes("checkbox") && !this.isShiftKey) {
        this.$refs.dataTable.clearSelection();
      }
      if(this.isShiftKey) {
        this.oldSelectRow = [...this.selectedRow];
      }

      // 註冊window上的mouseup事件, 否則不在範圍內會無法取消
      window.addEventListener("mouseup", this.handleMouseUp);
      this.$refs.dataTable.$el.addEventListener("mousemove", this.handleMouseMove);
    },
    handleMouseMove(event) {
      if(!this.isSelecting) {
        return;
      }

      const currentX = event.pageX;
      const currentY = event.pageY;

      const width = Math.abs(currentX - this.startX);
      const height = Math.abs(currentY - this.startY);

      this.updateSelectionBox(Math.min(this.startX, currentX), Math.min(this.startY, currentY), width, height);

      const boxRect = this.$refs.selectionBox.getBoundingClientRect();
      for (const tr of this.selectAbles) {
        const trRect = tr.getBoundingClientRect();
        let isSelected = boxRect.left < trRect.right &&
                       boxRect.right > trRect.left &&
                       boxRect.top < trRect.bottom &&
                       boxRect.bottom > trRect.top;
        
        const className = tr.className?.split(" ");
        if (!className || className.length === 0) {
          continue;
        }
        const index = parseInt(className.find(x => x.startsWith("myRow-")).replace("myRow-", ""));
        const oldSelectRowIndex = this.oldSelectRow.findIndex(x => x.id === this.assets[index].id);
        if(oldSelectRowIndex !== -1 && this.isShiftKey) {
          isSelected = !isSelected;
        }
        this.$refs.dataTable.toggleRowSelection(this.assets[index], isSelected);
      }
    },
    handleMouseUp() {
      this.isSelecting = false;
      this.$refs.selectionBox.style.display = "none";

      window.removeEventListener("mouseup", this.handleMouseUp);
      this.$refs.dataTable.$el.removeEventListener("mousemove", this.handleMouseMove);
    },
    updateSelectionBox(left, top, width, height) {
      this.$refs.selectionBox.style.left = `${left}px`;
      this.$refs.selectionBox.style.top = `${top}px`;
      this.$refs.selectionBox.style.width = `${width}px`;
      this.$refs.selectionBox.style.height = `${height}px`;
    },
  },
  computed: {
    anySelectedGrantable() {
      return this.selectedRow.some(() => true);
    },
    hasNoValidChnl() {
      return this.myChnls.length === 0;
    },
    hasNoActiveChnl() {
      return this.activeQueryForm.chnl === undefined;
    },
    ...mapGetters({
      myownOrg: "auth/orgName",
      assets: "asset/assets",
      total: "asset/total",
      sort: "asset/sort",
      order: "asset/order",
      parentIsEncrypt: "asset/parentIsEncrypt",
    }),
  },
};
</script>

<style>
.headericon {
  width: 1.2rem;
  height: 1.2rem;
  font-size: 1.2rem;
}
.headerpanel {
  padding-top: 10px;
  padding-left: 12px;
  padding-right: 0px;
  padding-bottom: 10px;
  margin-right: -12px;
}
.infoicon {
  width: 18px;
  height: 18px;
  margin-left: 4px;
  margin-right: 2px;
}
.selectionBox {
    position: absolute;
    border: 1px dashed #007bff;
    background-color: rgba(0, 123, 255, 0.2);
    pointer-events: none;
    display: none;
    z-index: 10;
}
</style>
